/* eslint-disable jsx-quotes */
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import useTrans from '../../hooks/useTrans';
import MetaSeo from '../MetaSeo';

export default function Home(props) {
  const trans = useTrans();

  const dataSEO = {
    title: `${trans.layout.home} | EYEFIRE`,
    description: trans.seo.home.description,
  };
  const dataApply = [
    {
      id: 1,
      title: 'Camera quan sát',
      img: '/assets/img/aiot/1.png',
      description: [
        {
          text:
            'Camera giám sát và lưu trữ tập trung, có thể đồng bộ dữ liệu lên máy chủ cloud',
        },
        {
          text: 'Xem ở bất kỳ đâu, trên máy tính hoặc thiết bị di động',
        },
      ],
    },
    {
      id: 2,
      title: 'giám sát an ninh',
      img: '/assets/img/aiot/2.png',
      description: [
        {
          text: 'Phát hiện có người lảng vảng quanh khu vực quan sát',
        },
        {
          text: 'Phát hiện và cảnh báo vượt hàng rào ảo',
        },
        {
          text: 'Phát hiện và cảnh báo xâm nhập trái phép khu vực cấm',
        },
        {
          text: 'Phát hiện và cảnh báo tụ tập đông người, đánh nhau',
        },
        {
          text: 'Phát hiện hành vi trộm cắp',
        },
      ],
    },
    {
      id: 3,
      title: 'cảnh báo nguy hiểm, phát hiện tai nạn',
      img: '/assets/img/aiot/3.png',
      description: [
        {
          text:
            'Giám sát an toàn, cảnh báo khi có người tới gần hoặc đi vào khu vực nguy hiểm như ao hồ, sông ngòi, khu vực độc hại, đường tàu, tới gần máy móc thiết bị nguy hiểm, tới gần công trường thi công',
        },
        {
          text:
            'Phát hiện tai nạn như có người trượt ngã trong bệnh viện, trường học, trong công trình, trong nhà máy',
        },
      ],
    },
    {
      id: 4,
      title: 'giám sát và thống kê lưu lượng giao thông',
      img: '/assets/img/aiot/4.png',
      description: [
        {
          text: 'Phân loại phương tiện giao thông',
        },
        {
          text: 'Đếm số lượng phương tiện theo từng loại',
        },
        {
          text: 'Nhận diện biển số',
        },
        {
          text: 'Phát hiện sai phạm',
        },
        {
          text: 'Phát hiện hành vi trộm cắp',
        },
      ],
    },
    {
      id: 5,
      title: 'phát hiện và cảnh báo cháy',
      img: '/assets/img/aiot/5.png',
      description: [
        {
          text:
            'Phát hiện có khói và cảnh báo ở các khu vực như toà nhà, nhà máy, kho bãi',
        },
        {
          text: 'Phát hiện hoả hoạn và cảnh báo sớm',
        },
      ],
    },
  ];

  return (
    <>
      <MetaSeo {...dataSEO} />
      <div className="main">
        <div className="home_banner">
          <div className="home_banner-container">
            <div className="home_banner-bg">
              <div className="home_banner-content">
                <div>
                  <img src="/assets/img/aiot/text_banner.svg" alt="" />
                  <p>
                    Biến camera thường thành AI Camera thông qua việc phân tích
                    và xử lý luồng video từ camera thời gian thực. Cảnh báo tức
                    thời, xem và lưu trữ tập trung, có thể đồng bộ dữ liệu lên
                    máy chủ cloud.
                  </p>
                </div>
              </div>

              <div className="home_banner-content-mb">
                <div>
                  <img src="/assets/img/aiot/img_mb.svg" alt="" />
                  <p>
                    Biến camera thường thành AI Camera thông qua việc phân tích
                    và xử lý luồng video từ camera thời gian thực. Cảnh báo tức
                    thời, xem và lưu trữ tập trung, có thể đồng bộ dữ liệu lên
                    máy chủ cloud.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="home_form">
          <div className="home_form-container">
            <h3>MÔ HÌNH</h3>
            <div>
              <img
                src="/assets/img/aiot/form.svg"
                alt=""
                className="fnnawj21ufjasf"
              />
            </div>
          </div>
        </div>

        <div className="home_form home_feature">
          <div className="home_form-container home_feature-container">
            <h3>CÁC TÍNH NĂNG NỔI BẬT AIOT CAMERA</h3>
            <div>
              <img
                src="/assets/img/aiot/feature.svg"
                alt=""
                className="fwnan22bfbabafw"
              />
            </div>
          </div>
        </div>

        <div className="applied_into">
          <div className="applied_into-container">
            <h3>Ứng dụng vào các bài toán</h3>

            {dataApply?.map((data, index) => {
              return (
                <div
                  key={index}
                  className={index === 4 ? 'nanhauwq' : `div_${index}`}
                >
                  <div>
                    <span>{`0${data.id}`}</span>
                    <h3
                      dangerouslySetInnerHTML={{
                        __html: data.title,
                      }}
                    ></h3>
                    <ul>
                      {data.description.map((el, idx) => {
                        return (
                          <li
                            key={idx}
                            dangerouslySetInnerHTML={{
                              __html: el.text,
                            }}
                          ></li>
                        );
                      })}
                    </ul>
                  </div>
                  <div>
                    <img src={data.img} alt="" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="home_form home_feature  home_fields">
          <div className="home_form-container home_feature-container  home_fields-container">
            <h3>ÁP DỤNG VÀO NHIỀU LĨNH VỰC</h3>
            <div>
              <img
                src="/assets/img/aiot/fields.svg"
                alt=""
                className="fjjaj2jqahfasfbhawh"
              />
            </div>
          </div>
        </div>

        <div className="home_contact">
          <div className="home_contact-container">
            <div>
              <h3 className="text-dt">
                VUI LÒNG LIÊN HỆ NGAY VỚI CHÚNG TÔI <br /> ĐỂ ĐƯỢC TƯ VẤN VÀ
                TRẢI NGHIỆM GIẢI PHÁP
              </h3>

              <h3 className="text-mb">
                VUI LÒNG LIÊN HỆ NGAY
                <br /> VỚI CHÚNG TÔI ĐỂ ĐƯỢC <br /> TƯ VẤN VÀ TRẢI NGHIỆM
                <br />
                GIẢI PHÁP
              </h3>
              <div className="home_contact-content">
                <div>
                  <img src="/assets/img/aiot/call_2.svg" alt="" />
                  <a type="phone" href="tel:024 3910 2030">
                    <p>Hotline</p>
                    <h3>024 3910 2030</h3>
                  </a>
                </div>
                <span></span>
                <div>
                  <img src="/assets/img/aiot/mail.svg" alt="" />
                  <a type="email" href="mailto:info@eyefire.vn">
                    <p>Email</p>
                    <h3>info@eyefire.vn</h3>
                  </a>
                </div>
              </div>

              <div className="home_contact-content-mb">
                <div>
                  <p>Hotline</p>
                  <div>
                    <img src="/assets/img/aiot/call_2.svg" alt="" />
                    <a type="phone" href="tel:024 3910 2030">
                      <h3>024 3910 2030</h3>
                    </a>
                  </div>
                </div>
                <span></span>
                <div>
                  <p>Email</p>
                  <div>
                    <img src="/assets/img/aiot/mail.svg" alt="" />
                    <a type="email" href="mailto:info@eyefire.vn">
                      <h3>info@eyefire.vn</h3>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
